import {
  CheckboxV2,
  type CheckboxV2Props,
} from "src/components/CheckboxV2/CheckboxV2.tsx";
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import React, { type ChangeEvent, type FocusEvent } from "react";
import { composeRefs } from "@exonn/hooks";

export type CheckboxFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = CheckboxV2Props & {
  name: TName;
  forceValue?: any;
} & Omit<ControllerProps<TFieldValues, TName>, "render">;

// todo: forward ref
export const CheckboxField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: CheckboxFieldProps<TFieldValues, TName>,
) => {
  const {
    name,
    control,
    disabled,
    forceValue,
    onChange: onChangeProp,
    onBlur: onBlurProp,
    rules,
    // defaultValue,
    shouldUnregister,
    ...restComponentProps
  } = props;

  return (
    <Controller
      key={name}
      name={name}
      rules={rules}
      // defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      // disabled={disabled} // commented because it breaks dirty state
      control={control}
      render={({
        field: { name, value, onChange, onBlur, ref },
        formState: { errors },
      }) => {
        const resolvedValue = forceValue != null ? forceValue : value;

        const handleChange = (value: ChangeEvent<HTMLInputElement>) => {
          onChangeProp?.(value);
          onChange(value);
        };
        const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
          onBlurProp?.(event);
          onBlur();
        };

        const error = errors?.root?.[name]?.message; // server error;
        return (
          <CheckboxV2
            ref={composeRefs(ref)}
            name={name}
            disabled={disabled}
            checked={resolvedValue}
            onChange={handleChange}
            onBlur={handleBlur}
            error={error}
            {...restComponentProps}
          />
        );
      }}
    />
  );
};
